import { ChevronDown, Edit, Key, Settings, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../services/auth.service";
import { getExpositorInfo } from "../../services/expositor.service";

interface UserData {
  name: string;
  email: string;
  birthday: string;
  city: string;
  state: string;
  zipcode: string;
  district: string;
  address: string;
  address_number: string;
  address_complement: string;
  phone: string;
  cpf: string;
  cnpj: string;
  brand_name: string;
  instagram_url: string;
  brand_description: string;
  brand_items: string;
  category_id: string;
}

interface AccountMenuProps {
  onOpenProfileModal: () => void;
  onOpenPasswordModal: () => void;
  userData: UserData;
  setUserData: (data: UserData) => void;
}

export default function AccountMenu({
  onOpenProfileModal,
  onOpenPasswordModal,
  userData,
  setUserData,
}: AccountMenuProps) {
  const [showActions, setShowActions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData.name) {
      getExpositorInfo().then((response) => {
        setUserData(response.user);
      });
    }
  }, [userData.name, setUserData]);

  return (
    <div className="relative w-full">
      <button
        onClick={() => setShowActions(!showActions)}
        className="flex items-center justify-between w-full p-3 text-white hover:bg-white/10 rounded-lg transition-colors"
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <User className="w-5 h-5 text-white" />
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-white">
              {userData.name || "Carregando..."}
            </p>
            <p className="text-xs text-white/70">{userData.email || ""}</p>
          </div>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-white/70 transition-transform ${
            showActions ? "rotate-180" : ""
          }`}
        />
      </button>

      {showActions && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="py-2">
            <button
              onClick={() => {
                onOpenProfileModal();
                setShowActions(false);
              }}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <Edit className="w-4 h-4 mr-3" />
              Editar Perfil
            </button>
            <button
              onClick={() => {
                onOpenPasswordModal();
                setShowActions(false);
              }}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <Key className="w-4 h-4 mr-3" />
              Alterar Senha
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
